"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScript = void 0;
var use_script_1 = require("./use-script");
Object.defineProperty(exports, "useScript", { enumerable: true, get: function () { return use_script_1.useScript; } });
